/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');

var SubmitBoardAnnualMeetingRequirements = require('../services/SubmitBoardAnnualMeetingRequirements');
var DepBoardAnnualMeetingRequireFormView = require('./DepBoardAnnualMeetingRequirementsFormView');

var tmplDepBoardAnnualMeetingRequireNewView = require('../templates/DepBoardAnnualMeetingRequirementsNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepBoardAnnualMeetingRequireNewView,

  className: 'dep-board-annual-meeting-require-new-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    boardAnnualMeetingRequireContainer: '.board-annual-meeting-require-form-container',
    submit: '.submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    boardAnnualMeetingRequireContainer: '@ui.boardAnnualMeetingRequireContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + this.entityId + '/dashboard',
            text: entityName
          },
          {
            text: 'New Board/Annual Meeting Requirements'
          }
        ]
      })
    );

    this.boardAnnualMeetingRequireForm = new DepBoardAnnualMeetingRequireFormView({
      model: this.model
    });
    this.showChildView('boardAnnualMeetingRequireContainer', this.boardAnnualMeetingRequireForm);
  },

  onClickSubmit: function(event) {
    event.preventDefault();
    var self = this;
    this.boardAnnualMeetingRequireForm.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      var formData = self.getFormData();
      SubmitBoardAnnualMeetingRequirements(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:dp:entity', self.entityId);
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  getFormData: function() {
    var formData = this.boardAnnualMeetingRequireForm.getFormData();

    formData.entityId = this.entityId;

    return formData;
  }
});
